'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _myPlaylists = require('redux/modules/my-playlists');

var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);

var _audioplayer = require('redux/modules/audioplayer');

var audioplayerActions = _interopRequireWildcard(_audioplayer);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _EditableField = require('components/EditableField/EditableField');

var _EditableField2 = _interopRequireDefault(_EditableField);

var _myPlaylists2 = require('helpers/my-playlists');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./MyPlaylistInfo.scss');

var MyPlaylistName = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    playerAlbum: state.audioplayer.album,
    updateMyPlaylistsLoading: state.myPlaylists.updateMyPlaylistsLoading
  };
}, (0, _extends3.default)({}, myPlaylistsActions, audioplayerActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(MyPlaylistName, _Component);

  function MyPlaylistName() {
    (0, _classCallCheck3.default)(this, MyPlaylistName);
    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistName.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistName)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyPlaylistName, [{
    key: 'saveName',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(name) {
        var _props, updateMyPlaylistName, playlist, playerAlbum, updateAlbumName;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, updateMyPlaylistName = _props.updateMyPlaylistName, playlist = _props.playlist, playerAlbum = _props.playerAlbum, updateAlbumName = _props.updateAlbumName;
                _context.next = 3;
                return updateMyPlaylistName({ guid: playlist.guid, name: name }).promise;

              case 3:
                if (playerAlbum.projectId === playlist.guid) {
                  updateAlbumName({ name: name });
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveName(_x) {
        return _ref.apply(this, arguments);
      }

      return saveName;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          playlist = _props2.playlist,
          updateMyPlaylistsLoading = _props2.updateMyPlaylistsLoading,
          className = _props2.className,
          textClass = _props2.textClass;


      return _react2.default.createElement(_EditableField2.default, {
        className: className,
        textClass: textClass,
        onSave: this.saveName,
        value: playlist.name,
        loading: updateMyPlaylistsLoading,
        inputProps: { maxLength: _myPlaylists2.nameMaxLength },
        inputClass: styles.nameInput,
        containerClass: styles.nameInputContainer
      });
    }
  }]);
  return MyPlaylistName;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  playerAlbum: _propTypes2.default.object,
  playlist: _propTypes2.default.object,
  textClass: _propTypes2.default.string,
  updateAlbumName: _propTypes2.default.func,
  updateMyPlaylistName: _propTypes2.default.func,
  updateMyPlaylistsLoading: _propTypes2.default.bool
}, _class3.defaultProps = {
  playerAlbum: {},
  playlist: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'saveName', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'saveName'), _class2.prototype)), _class2)) || _class);
exports.default = MyPlaylistName;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylist/components/MyPlaylistName.js
// module id = 2164
// module chunks = 1